// Don't use replaceAll method due to browser support issues.
export var stringToId = function stringToId(value) {
  return value.trim().toLowerCase().replace(/(\s)/g, '-');
};